import React from 'react';
import InputField from '../../../Forms/Input/InputField';
import SvgIcon from '../../../SvgIcon/SvgIcon';

interface CashPaymentSectionProps {
  cashReceived: number | '';
  onCashChange: (value: number | '') => void;
  totalToPay: number;
}

const CashPaymentSection: React.FC<CashPaymentSectionProps> = ({
  cashReceived,
  onCashChange,
  totalToPay,
}) => {

  // ✅ Normalización segura de decimales
  const round2 = (n: number) => Number(n.toFixed(2));

  const safeTotal = round2(totalToPay);
  const safeCash = cashReceived === '' ? '' : round2(Number(cashReceived));

  const computedChange =
    safeCash !== '' ? round2((safeCash as number) - safeTotal) : '';

  const showFeedback = safeCash !== '' && Number(safeCash) >= 0;
  const isInsufficient =
    showFeedback && (safeCash as number) < safeTotal; // comparación segura
  const isEnough =
    showFeedback && (safeCash as number) >= safeTotal;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value.trim() === '') {
      onCashChange('');
      return;
    }

    const parsed = Number(value);
    if (!isNaN(parsed) && parsed >= 0) {
      onCashChange(round2(parsed));
    }
  };

  return (
    <div className="space-y-3">
      <div className="grid gap-4 sm:grid-cols-2">
        <InputField
          label="Efectivo Recibido"
          name="cashReceived"
          iconKey="dollar"
          type="number"
          value={safeCash}
          onChange={handleChange}
          min={0}
        />

        <InputField
          label="Cambio"
          name="change"
          iconKey="dollar"
          type="text"
          value={computedChange !== '' ? `$${computedChange}` : ''}
          disabled
        />
      </div>

      {showFeedback && (
        <div
          className={`
            flex items-center gap-3 rounded-lg px-4 py-3 text-white transition
            ${isInsufficient ? 'bg-[#DC3545]' : ''}
            ${isEnough ? 'bg-[#3CA745]' : ''}
          `}
        >
          <SvgIcon name="dollar" className="h-5 w-5 text-white" />

          <span className="font-medium text-sm">
            {isInsufficient && 'Efectivo insuficiente'}
            {isEnough && 'Pago correcto'}
          </span>
        </div>
      )}
    </div>
  );
};


export default CashPaymentSection;
